export default __webpack_public_path__ + "static/media/Arrow-another.46433702.svg";